"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var InputText = (function () {
    function InputText(el) {
        this.el = el;
    }
    Object.defineProperty(InputText.prototype, "filled", {
        get: function () {
            return this.el.nativeElement.value && this.el.nativeElement.value.length;
        },
        enumerable: true,
        configurable: true
    });
    InputText.prototype.onBlur = function (e) {
        //To trigger change detection to manage ui-state-filled for material labels
    };
    return InputText;
}());
__decorate([
    core_1.HostListener('blur', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InputText.prototype, "onBlur", null);
InputText = __decorate([
    core_1.Directive({
        selector: '[pInputText]',
        host: {
            '[class.ui-inputtext]': 'true',
            '[class.ui-corner-all]': 'true',
            '[class.ui-state-default]': 'true',
            '[class.ui-widget]': 'true',
            '[class.ui-state-filled]': 'filled'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], InputText);
exports.InputText = InputText;
var InputTextModule = (function () {
    function InputTextModule() {
    }
    return InputTextModule;
}());
InputTextModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule],
        exports: [InputText],
        declarations: [InputText]
    })
], InputTextModule);
exports.InputTextModule = InputTextModule;
//# sourceMappingURL=inputtext.js.map


//////////////////
// WEBPACK FOOTER
// ./~/primeng/components/inputtext/inputtext.js
// module id = 97
// module chunks = 323